import { Modal } from "react-bootstrap";
import { LoadingSpinnerDotted } from "../loading-spinner/Loader";

export const DeleteModal = ({ message, isLoading, showDeleteModal, setShowDeleteModal, confirmFnc }) => {
    const handleClose = () => setShowDeleteModal(false);
    return (
        <Modal
            show={showDeleteModal}
            onHide={handleClose}
            keyboard={false}
            size="sm"
            className="add-travellers-modal delete-travellers-modal"
            centered
        >
            <Modal.Body>
                <p>{message}?</p>
                <div className="mt-3 justify-content-center d-flex">
                    <button type="button" className="btn btn-secondary-color btn-border-color" onClick={handleClose}>
                        No
                    </button>
                    <button onClick={confirmFnc} type="submit" className="btn btn-primary-color btn-border-color ms-3">
                        {isLoading ? <LoadingSpinnerDotted /> : "Yes"}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}